import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/whatsapp";

export const WhatsAppSection = () => (
  <section className="bg-[#145DA0]" data-testid="whatsapp-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:items-center">
      <div>
        <h2 className="nx-head text-3xl md:text-4xl font-semibold text-[#FFFFFF]">
          Schnell &amp; unkompliziert anfragen
        </h2>
        <p className="mt-5 text-base text-[#DBEAFE] leading-relaxed max-w-xl">
          Sie haben Fragen oder benötigen kurzfristig Unterstützung? Schreiben Sie uns direkt über WhatsApp.
          Wir melden uns schnellstmöglich bei Ihnen.
        </p>
      </div>
      <div className="lg:justify-self-end">
        <a
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          data-testid="whatsapp-section-cta"
          className="nx-btn-action w-full lg:w-auto"
        >
          <MessageCircle size={18} strokeWidth={1.9} /> Jetzt über WhatsApp schreiben
        </a>
        <p className="mt-4 text-xs text-[#DBEAFE] lg:text-right">
          Kostenlose Anfrage · Schnelle Rückmeldung · Unverbindlich
        </p>
      </div>
    </div>
  </section>
);
